import Axios from "axios"
import { errorHandler, generateRequestHeaders } from "../../utils"
import api from '../../api'
import { TIMEOUT } from "../../constants"

const service = {
  async getData(id) {
    return new Promise(function(resolve, reject){
      Axios.get(`${api.base}${api.resources}${id}/`, {
        timeout: TIMEOUT,
        headers: generateRequestHeaders()
      }).then(res => {
        if(res.data){
          resolve(res.data)
        }else{
          resolve(res)
        }
      }).catch(err => {
        const message = errorHandler(err)
        reject(message)
      })
    })
  },

  /**
   * DELETE
   */
  async delete(id){
    return new Promise(function(resolve, reject){
      if(id){
        Axios.delete(`${api.base}${api.resources}${id}/`, {
          headers: generateRequestHeaders()
        })
        .then(res => {
          console.log(res)
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },
}

export default service
